import React, { useState, createContext } from 'react';

export const SearchContext = createContext();

export default function SearchContextProvider(props) {
  const [searchTerm, setSearchTerm] = useState('');
  const [initiateSearch, setInitiateSearch] = useState(false);

  const localSearchTerm = localStorage.setItem('localSearchTerm', searchTerm);

  return (
    <SearchContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        initiateSearch,
        setInitiateSearch,
        localSearchTerm,
      }}
    >
      {props.children}
    </SearchContext.Provider>
  );
}
